import { BonusCardFront } from "@/Components/BonusCardFront"
import { MainButton } from "@/Components/MainButton"
import { allColors } from "@/utils/data"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setModalData } from "@/store/globalSlice"
import { getUserCreds, socket } from "@/utils/utils"
import Color from "color"
import { useNavigate } from "react-router-dom"
import { mapDesigns } from "@mono/mapDesigns"
import Money from "@/Components/Money"
import Modal from "@/Components/Modal"

interface JailModalProps {}

const JailFreeCardModal: React.FC<JailModalProps> = () => {
  const dispatch = useAppDispatch()
  const myGame = useAppSelector((state) => state.global.myGame)
  const modalData = useAppSelector((state) => state.global.modalData)
  const nav = useNavigate()
  const activePlayer = myGame?.situation?.players.find(
    (p) => p.id === getUserCreds().email
  )
  if (!activePlayer) return null
  if (!myGame?.situation) return null
  const handleClose = () => {
    dispatch(setModalData({ jailFreeCard: { type: "chance", visible: false } }))
  }
  const handleSellJailFreeCard = () => {
    dispatch(
      setModalData({ jailFreeCard: { type: "chance", visible: false } })
    )
    socket.emit(
      "game.sell-jail-free-card-to-bank",
      myGame?.id as string,
      activePlayer.order,
      modalData.jailFreeCard.type
    )
  }
  return (
    <Modal
      data-testid="game.jail-free-modal"
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10"
      onClose={handleClose}
      closeTestId="trade.close-btn"
      icon={<i className="fa-solid fa-ticket text-white text-2xl"></i>}
      title="Get Out of Jail Free"
      subtitle="Sell this card to the bank"
      contentClassName="flex flex-col gap-4 px-8 pb-8"
    >
      <BonusCardFront
        className="w-full"
        type={modalData.jailFreeCard.type as BonusCardType}
        card={
          mapDesigns[0].allChances.find(
            (item) => item.id === "get-out-of-jail-free"
          ) as IBonusCard
        }
      ></BonusCardFront>

      <div className="flex flex-col gap-4">
        <MainButton
          onClick={handleSellJailFreeCard}
          data-testid="game.jail-free-modal-sell-btn"
          baseColor={new Color(allColors.buttonBaseColors.green).hex()}
        >
          <div className="flex items-center gap-2 ">
            <i className="fa-money-bull fa-solid text-white fa-xl"></i>
            <div className="text-white font-medium font-poppins text-xl flex">
              Sell for
              <Money money={50} className="gap-2" iconClass="h-1/2"></Money>
            </div>
          </div>
        </MainButton>
      </div>
    </Modal>
  )
}

export default JailFreeCardModal
